import AccionesAprendizCell from "@/components/AccionesTablas/Aprendiz.acciones";
import type { Aprendiz } from "@/interfaces/user.interface";
import type { ColumnDef } from "@tanstack/react-table";
import { formatearFechaISOaDDMMYYYY } from "../utils";

export function getAprendizColumns(
  queryKey: ReadonlyArray<unknown>,
): ColumnDef<Aprendiz>[] {
  return [
    {
      accessorKey: "usuario.id",
      header: "ID",
      enableSorting: false,
    },
    {
      accessorKey: "usuario.nombreUsuario",
      header: "Usuario",
    },
    {
      accessorKey: "usuario.nombre",
      header: "Nombre",
    },
    {
      accessorKey: "usuario.apellidoPaterno",
      header: "Apellido Paterno",
    },
    {
      accessorKey: "usuario.apellidoMaterno",
      header: "Apellido Materno",
    },
    {
      accessorKey: "usuario.correo",
      header: "Correo",
    },
    {
      accessorKey: "ultimaActividad",
      header: "Última Actividad",
      cell: ({ getValue }) => {
        const value = getValue() as string | null;
        return value ? formatearFechaISOaDDMMYYYY(value) : "";
      },
    },
    {
      id: "acciones",
      header: "Acciones",
      cell: ({ row }) => (
        <AccionesAprendizCell aprendiz={row.original} queryKey={queryKey} />
      ),
    },
  ];
}
